import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const TagManager = (props) => {
    const {
        setNewEditTagModalOpen,
        setNewDuplicateTagModalOpen,
        setNewDeleteTagModalOpen,
        setNewAddProductModalOpen,
        setNewAddConfigProdModalOpen,
        opsDisable,
    } = props;

    return (
        <div className="divide-y-2 divide-solid">
            <ul>
                <li className="mb-4">
                    <button
                        className={classNames(
                            'swegon-like-button w-full text-left',
                            opsDisable ? 'text-gray-30' : '',
                        )}
                        onClick={() => setNewEditTagModalOpen(true)}
                        disabled={opsDisable}
                    >
                        <FontAwesomeIcon
                            className="mr-6"
                            icon="fa-solid fa-pen"
                        />
                        Edit Tag
                    </button>
                </li>
                <li className="mb-4">
                    <button
                        className={classNames(
                            'swegon-like-button w-full text-left',
                            opsDisable ? 'text-gray-30' : '',
                        )}
                        onClick={() => setNewDuplicateTagModalOpen(true)}
                        disabled={opsDisable}
                    >
                        <FontAwesomeIcon
                            className="mr-6"
                            icon="fa-solid fa-copy"
                        />
                        Duplicate Tag
                    </button>
                </li>
                <li className="mb-2">
                    <button
                        className={classNames(
                            'swegon-like-button w-full text-left',
                            opsDisable ? 'text-gray-30' : '',
                        )}
                        onClick={() => setNewDeleteTagModalOpen(true)}
                        disabled={opsDisable}
                    >
                        <FontAwesomeIcon
                            className="mr-6"
                            icon="fa-solid fa-trash-can"
                        />
                        Delete Tag
                    </button>
                </li>
            </ul>
            <ul>
                <li className="mt-2 mb-2">
                    <button
                        className={classNames(
                            'swegon-like-button w-full text-left',
                            opsDisable ? 'text-gray-30' : '',
                        )}
                        onClick={() => setNewAddProductModalOpen(true)}
                        disabled={opsDisable}
                    >
                        <FontAwesomeIcon
                            className="mr-6"
                            icon="fa-solid fa-plus"
                        />
                        Add Product
                    </button>
                </li>
            </ul>
            <ul>
                <li className="mt-2">
                    <button
                        className={classNames(
                            'swegon-like-button w-full text-left',
                            opsDisable ? 'text-gray-30' : '',
                        )}
                        onClick={() => setNewAddConfigProdModalOpen(true)}
                        disabled={opsDisable}
                    >
                        <FontAwesomeIcon
                            className="mr-6"
                            icon="fa-solid fa-plus"
                        />
                        Add Configured Product
                    </button>
                </li>
            </ul>
        </div>
    );
};
